// extracted by mini-css-extract-plugin
export default {"c-list":"list_c-list__H9cLb","c-list__item":"list_c-list__item__Ikadj","c-list--decimal":"list_c-list--decimal__+l0lG","c-list--sub":"list_c-list--sub__lLfe3"};